import React, { useState, useEffect } from 'react';
import { Building2, Tag, FileText, CheckCircle2, X, UploadCloud, Send , Loader2 , MapPin } from 'lucide-react';
import toast from 'react-hot-toast';
import LeadProfile from './components/LeadProfile';
import { useAuth } from '../../context/AuthContext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { sortStatuses } from '../../utils/statusUtils';
import Dropdown from '../../components/Dropdown';
import { API_URL, BASE_URL } from '../../utils/api';

const AddLead = ({ onClose, initialData, isViewMode = false, onEdit, onDelete, onAction }) => {
  const { user: currentUser } = useAuth();
  
  const [shopName, setShopName] = useState('');
  const [contactPerson, setContactPerson] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('Surat');
  const [state, setState] = useState('Gujarat');
  const [pincode, setPincode] = useState('');

  const [agencyType, setAgencyType] = useState('copy shop');
  const [isOtherAgencyType, setIsOtherAgencyType] = useState(false);
  const [otherAgencyType, setOtherAgencyType] = useState('');

  const [interestedType, setInterestedType] = useState('');
  const [machineType, setMachineType] = useState('');
  const [machineBrand, setMachineBrand] = useState('');
  const [otherInterest, setOtherInterest] = useState('');
  const [machineModel, setMachineModel] = useState('');
  
  const [assignee, setAssignee] = useState(currentUser?.name || '');
  const [status, setStatus] = useState('');
  const [customerType, setCustomerType] = useState('');
  const [leadSource, setLeadSource] = useState('Just Dial');
  const [notes, setNotes] = useState('');
  
  const [followUpDate, setFollowUpDate] = useState('');
  const [followUpTime, setFollowUpTime] = useState('');
  const [followUpDays, setFollowUpDays] = useState('');
  const [originalFollowUp, setOriginalFollowUp] = useState(null);
  const [followUpId, setFollowUpId] = useState(null);
  
  const [frontCard, setFrontCard] = useState(null);
  const [backCard, setBackCard] = useState(null);
  
  const [showBrochureModal, setShowBrochureModal] = useState(false);
  const [createdLead, setCreatedLead] = useState(null);

  // Dynamic master data state
  const [leadTypes, setLeadTypes] = useState([]);
  const [machines, setMachines] = useState([]);
  const [leadSources, setLeadSources] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [users, setUsers] = useState([]);
  const [customerTypes, setCustomerTypes] = useState([]);
  
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [locationError, setLocationError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  
  useEffect(() => {
    

    const fetchMasters = async () => {
      try {
        const { default: api } = await import('../../utils/api');
        const [typesRes, machinesRes, sourcesRes, statusesRes, usersRes, customerTypesRes] = await Promise.all([
          api.get('/masters/lead-types').catch(() => ({ data: [] })),
          api.get('/masters/machines').catch(() => ({ data: [] })),
          api.get('/masters/lead-sources').catch(() => ({ data: [] })),
          api.get('/masters/status').catch(() => ({ data: [] })),
          api.get('/auth/users').catch(() => ({ data: [] })),
          api.get('/masters/customer-types').catch(() => ({ data: [] }))
        ]);
        setLeadTypes(typesRes.data.filter(t => t.status === 'Active'));
        setMachines(machinesRes.data.filter(m => m.status === 'Active' && m.name && m.name.trim() !== ''));
        
        const activeSources = sourcesRes.data.filter(s => s.status === 'Active');
        setLeadSources(activeSources);
        if (!initialData) {
          const defaultSource = activeSources.find(s => s.name.toLowerCase().includes('just dial') || s.name.toLowerCase() === 'just dial');
          if (defaultSource) setLeadSource(defaultSource.name);
        }

        const activeStatuses = sortStatuses(statusesRes.data.filter(s => s.status === 'Active'));
        setStatuses(activeStatuses);
        setUsers(usersRes.data.filter(u => u.role !== 'Admin' && u.status === 'Active'));
        setCustomerTypes(customerTypesRes.data.filter(c => c.status === 'Active'));
        
        if (!initialData && activeStatuses.length > 0) {
          const newStatus = activeStatuses.find(s => s.name.toLowerCase().includes('new')) || activeStatuses[0];
          setStatus(newStatus.name);
        }
        if (!initialData) {
          const activeCustomerTypes = customerTypesRes.data.filter(c => c.status === 'Active');
          const hotType = activeCustomerTypes.find(c => c.name.toLowerCase() === 'hot') || activeCustomerTypes[0];
          if (hotType) setCustomerType(hotType.name);
        }
      } catch (err) {
        console.error('Failed to fetch master data', err);
      }
    };
    fetchMasters();
  }, []);
  
  
  
  useEffect(() => {
    if (initialData) {
      setShopName(initialData.companyName || initialData.name || '');
      setContactPerson(initialData.contactPerson || initialData.contact || '');
      setContactPhone(initialData.contactPhone || '');
      setContactEmail(initialData.contactEmail || '');
      setPhone(initialData.phone || '');
      setEmail(initialData.email || '');
      setFrontCard(initialData.frontCard || null);
      setBackCard(initialData.backCard || null);
      let rawAddr1 = initialData.address || '';
      let rawAddr2 = initialData.address2 || '';
      const cleanAddr1 = rawAddr1.replace(/\s*\[GPS:.*?\]/gi, '').trim();
      const cleanAddr2 = rawAddr2.replace(/\s*\[GPS:.*?\]/gi, '').trim();
      setAddress(cleanAddr1);
      setAddress2(cleanAddr2);
      setCity(initialData.city || 'Surat');
      setState(initialData.state || 'Gujarat');
      setPincode(initialData.pincode || '');

      let latVal = initialData.latitude;
      let lngVal = initialData.longitude;
      if ((latVal === undefined || latVal === null || latVal === '') && rawAddr1) {
        const gpsMatch = rawAddr1.match(/\[GPS:\s*Lat:\s*([\d.-]+),\s*Lon:\s*([\d.-]+)\]/i);
        if (gpsMatch) {
          latVal = parseFloat(gpsMatch[1]);
          lngVal = parseFloat(gpsMatch[2]);
        }
      }
      if (latVal !== undefined && latVal !== null && latVal !== '') setLatitude(latVal);
      if (lngVal !== undefined && lngVal !== null && lngVal !== '') setLongitude(lngVal);

      setAgencyType(initialData.agencyType || 'copy shop');
      setIsOtherAgencyType(initialData.otherAgencyType ? true : false);
      setOtherAgencyType(initialData.otherAgencyType || '');
      
      setInterestedType(initialData.interestType || '');
      setMachineType(initialData.machineType || '');

      setMachineBrand(initialData.machineBrand || initialData.machine?.name || '');
      setMachineModel(initialData.machineModel || '');
      setStatus(initialData.status && initialData.status !== 'Unknown' ? (initialData.status.name || initialData.status) : '');
      setCustomerType(initialData.customerType || initialData.customerType?.name || '');
      setAssignee(initialData.assignee !== 'Unassigned' ? initialData.assignee : '');
      setLeadSource(initialData.source !== 'Unknown' ? (initialData.source?.name || initialData.source) : 'Just Dial');

      if (initialData.followups && initialData.followups.length > 0) {
        const validFollowups = initialData.followups.filter(f => f.type !== 'System');
        
        if (validFollowups.length > 0) {
          const now = new Date();
          const futureFollowups = validFollowups.filter(f => new Date(f.date) >= now);
          futureFollowups.sort((a, b) => new Date(a.date) - new Date(b.date));
          
          const targetFollowup = futureFollowups.length > 0 ? futureFollowups[0] : [...validFollowups].sort((a, b) => new Date(b.date) - new Date(a.date))[0];
          
          if (targetFollowup && targetFollowup.date) {
            const d = new Date(targetFollowup.date);
            setFollowUpDate(d);
            const hours = String(d.getHours()).padStart(2, '0');
            const mins = String(d.getMinutes()).padStart(2, '0');
            setFollowUpTime(`${hours}:${mins}`);
            setOriginalFollowUp(d.getTime());
            setFollowUpId(targetFollowup.id);
            
            const now = new Date();
            const diffTime = d - now;
            if (diffTime > 0) {
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              setFollowUpDays(diffDays);
            } else {
              setFollowUpDays('');
            }
          }
        }
      }
    }
  }, [initialData]);

  // Handle calculation for follow up days
  const handleFollowUpDaysChange = (days) => {
    setFollowUpDays(days);
    if (days && !isNaN(days)) {
      const d = new Date();
      d.setDate(d.getDate() + parseInt(days));
      setFollowUpDate(d);
    } else {
      setFollowUpDate(null);
    }
  };

  const handleFollowUpDateChange = (date) => {
    setFollowUpDate(date);
    if (date) {
      const now = new Date();
      const diffTime = Math.abs(date - now);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setFollowUpDays(diffDays);
    } else {
      setFollowUpDays('');
    }
  };

  const handleInterestTypeChange = (val) => {
    setInterestedType(val);
    if (val === 'In Future') {
      const scheduleStatus = statuses.find(s => s.name.toLowerCase().includes('schedule'));
      if (scheduleStatus) setStatus(scheduleStatus.name);
    } else if (val === 'Not at all' || val === 'Not at all of use') {
      const lostStatus = statuses.find(s => s.name.toLowerCase().includes('lost'));
      if (lostStatus) setStatus(lostStatus.name);
    }
  };

  
  
  const handleSave = async (e) => {
    e.preventDefault();
    if (isViewMode) return;
        // Phone Validations
    const newErrors = {};
    const phoneRegex = /^\d{10}$/;
    if (!shopName?.trim()) newErrors.shopName = 'Agency / Shop Name is required';
    if (!phone?.trim()) newErrors.phone = 'Phone Number is required';
    else if (!phoneRegex.test(phone.replace(/\D/g, ''))) newErrors.phone = 'Phone number must be exactly 10 digits';
    
    if (!email?.trim()) newErrors.email = 'Email Address is required';
    else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) newErrors.email = 'Please enter a valid email address';
    }

    if (!address?.trim()) newErrors.address = 'Address Line 1 is required';
    if (!city?.trim()) newErrors.city = 'City is required';
    if (!state?.trim()) newErrors.state = 'State is required';
    if (!pincode?.trim()) newErrors.pincode = 'Pincode is required';

    if (!contactPerson?.trim()) newErrors.contactPerson = 'Contact Person is required';
    if (!contactPhone?.trim()) newErrors.contactPhone = 'Phone Number is required';
    else if (!phoneRegex.test(contactPhone.replace(/\D/g, ''))) newErrors.contactPhone = 'Phone number must be exactly 10 digits';

    if (contactEmail) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(contactEmail)) newErrors.contactEmail = 'Please enter a valid email address';
    }

    if (!leadSource) newErrors.leadSource = 'Please select a Lead Source';
    if (!agencyType) newErrors.agencyType = 'Please select an Agency / Shop Type';
    if (agencyType === 'other' && !otherAgencyType) newErrors.otherAgencyType = 'Please specify Other Agency Type';
    
    if (!interestedType) newErrors.interestedType = 'Please select an Interest Type';
    if ((interestedType === 'Interested in machine' || interestedType === 'In Future')) {
      if (!machineType) newErrors.machineType = 'Please select a Machine Type';
      if (!machineBrand) newErrors.machineBrand = 'Please select a Machine Brand';
      if (!machineModel) newErrors.machineModel = 'Please specify a Machine Model';
    }

    if (!status) newErrors.status = 'Please select an Initial Status';
    if (!assignee) newErrors.assignee = 'Please assign an Executive';
    if (!customerType) newErrors.customerType = 'Please select a Customer Type';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error('Please fix the errors in the form');
      return;
    }
    
    setErrors({});
    setIsSubmitting(true);
    try {
      const { default: api } = await import('../../utils/api');
      
      const machineObj = machines.find(m => m.name === machineBrand);
      const sourceObj = leadSources.find(s => s.name === leadSource);
      const statusObj = statuses.find(s => s.name === status);
      const customerTypeObj = customerTypes.find(c => c.name === customerType);
      const userObj = users.find(u => u.name === assignee || u.name + ' (' + u.role + ')' === assignee);

      let finalFollowUpDate = null;
      if (followUpDate) {
        const d = new Date(followUpDate);
        if (followUpTime) {
          const [hours, minutes] = followUpTime.split(':');
          d.setHours(hours, minutes, 0, 0);
        }
        
        if (!initialData || d.getTime() !== originalFollowUp) {
          finalFollowUpDate = d.toISOString();
        }
      }

      let frontCardBase64 = frontCard;
      let backCardBase64 = backCard;

      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });

      if (frontCard instanceof File) {
        frontCardBase64 = await toBase64(frontCard);
      }
      if (backCard instanceof File) {
        backCardBase64 = await toBase64(backCard);
      }

      const payload = {
        companyName: shopName,
        contactPerson: contactPerson,
        contactPhone: contactPhone,
        contactEmail: contactEmail,
        phone: phone,
        email: email,
        address: address,
        address2: address2,
        city: city,
        state: state,
        pincode: pincode,
        agencyType: agencyType,
        otherAgencyType: isOtherAgencyType ? otherAgencyType : null,
        interestType: interestedType,
        machineType: machineType,
        frontCard: frontCardBase64,
        backCard: backCardBase64,
        notes: notes,
        machineId: machineObj ? machineObj.id : null,
        machineModel: machineModel,
        leadSourceId: sourceObj ? sourceObj.id : null,
        statusId: statusObj ? statusObj.id : null,
        customerTypeId: customerTypeObj ? customerTypeObj.id : null,
        latitude,
        longitude,
        isCustomer: statusObj ? ['won', 'completed', 'complete'].includes(statusObj.name.toLowerCase()) : false,
        userId: userObj ? userObj.id : null,
        followUpDate: finalFollowUpDate,
        followUpTime: followUpTime || null,
        followUpId: followUpId
      };

      if (initialData && initialData.id) {
        await api.put(`/leads/${initialData.id}`, payload);
        toast.success('Lead updated successfully!');
        onClose(true);
      } else {
        const res = await api.post('/leads', payload);
        toast.success('Lead created successfully!');
        
        if (machineObj && machineObj.brochure) {
           setCreatedLead(res.data);
           setShowBrochureModal(true);
        } else {
           onClose(true);
        }
      }
      
    } catch (err) {
      console.error(err);
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
        toast.error('Please fix the errors in the form');
      } else {
        toast.error(err.response?.data?.message || err.response?.data?.error || 'Failed to save lead');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const sendBrochureViaEmail = async () => {
    try {
      const { default: api } = await import('../../utils/api');
      await api.post(`/leads/${createdLead.id}/send-brochure`, { baseUrl: BASE_URL });
      toast.success('Brochure sent via Email successfully!');
      setShowBrochureModal(false);
      onClose(true);
    } catch (err) {
      toast.error('Failed to send brochure via Email');
    }
  };

  const sendBrochureViaWhatsApp = () => {
    const phone = createdLead?.contactPhone || createdLead?.phone || '';
    const cleanPhone = phone.replace(/\D/g, '');
    const finalPhone = cleanPhone.length === 10 ? `91${cleanPhone}` : cleanPhone;
    
    const machineObj = machines.find(m => m.name === machineBrand);
    let brochureLink = '';
    if (machineObj && machineObj.brochure) {
       const path = machineObj.brochure.startsWith('/') ? machineObj.brochure : `/${machineObj.brochure}`;
       brochureLink = `\n\nBrochure: ${BASE_URL}${path}`;
    }
    
    const name = createdLead?.contactPerson || createdLead?.companyName || 'Customer';
    const message = encodeURIComponent(`Hello ${name},\n\nThank you for visiting us! Here are the details for the ${machineBrand} ${machineModel} machine you inquired about.${brochureLink}\n\nPlease let us know if you have any questions.`);
    
    window.open(`https://wa.me/${finalPhone}?text=${message}`, '_blank');
    
    toast.success('Opened WhatsApp!');
    setShowBrochureModal(false);
    onClose(true);
  };

  if (isViewMode && initialData) {
    return <LeadProfile 
      lead={initialData} 
      onClose={onClose} 
      onEditLead={onEdit} 
      onDeleteLead={onDelete} 
      onActionLead={onAction} 
    />;
  }

  if (showBrochureModal) {
    return (
      <div style={{ padding: '3rem', textAlign: 'center' }}>
         <CheckCircle2 size={64} color="var(--color-primary)" style={{ margin: '0 auto 1rem auto' }} />
         <h2 className="text-2xl font-bold mb-4">Lead Created!</h2>
         <p className="mb-6">How would you like to send the brochure for the selected machine to the customer?</p>
         <div className="flex gap-4 justify-center">
            <button className="btn" style={{ border: '1px solid var(--color-border)' }} onClick={() => onClose(true)}>Skip</button>
            <button className="btn btn-primary flex items-center gap-2" onClick={sendBrochureViaEmail}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
              Send via Email
            </button>
            <button className="btn flex items-center gap-2" style={{ backgroundColor: '#25D366', color: 'white', border: 'none' }} onClick={sendBrochureViaWhatsApp}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 3.4L3 21"/><path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1"/></svg>
              Send via WhatsApp
            </button>
         </div>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', flex: 1 }}>
      <div 
        className="modal-header" 
        style={{ padding: '1rem 1.5rem', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f9fafb', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', flexShrink: 0 }}
      >
        <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 'bold', color: 'var(--color-text-main)' }}>
          {initialData ? 'Edit Lead' : 'Add New Lead'}
        </h2>
        <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', padding: '0.25rem' }} title="Close">
          <X size={20} />
        </button>
      </div>

      <div style={{ padding: '1.5rem', flex: 1, overflowY: 'auto' }}>
        <form onSubmit={handleSave} className="flex-col gap-8" noValidate>
          <fieldset disabled={isViewMode} style={{ border: 'none', padding: 0, margin: 0 }}>
            {/* Section 1: Agency/Shop Details */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-6 border-b pb-3" style={{ borderColor: 'var(--color-border)' }}>
                <Building2 size={22} color="var(--color-primary)" />
                <h3 style={{ fontSize: '0.95rem', fontWeight: '700', color: 'var(--color-primary)', margin: 0 }}>Agency / Shop Details</h3>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem', marginBottom: '1.5rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Lead Source <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <Dropdown
                    placeholder="Select Source..."
                    value={leadSource}
                    onChange={(val) => setLeadSource(val)}
                    options={leadSources.map(s => ({ value: s.name, label: s.name }))}
                  />
                  {errors.leadSource && <div className="text-danger text-xs mt-1">{errors.leadSource}</div>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Agency / Shop Type <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <Dropdown
                    placeholder="Select Type..."
                    value={agencyType}
                    onChange={(val) => {
                      setAgencyType(val);
                      if (val === 'other') setIsOtherAgencyType(true);
                      else setIsOtherAgencyType(false);
                    }}
                    options={[
                      { value: 'copy shop', label: 'Copy Shop' },
                      { value: 'other', label: 'Other' }
                    ]}
                  />
                  {errors.agencyType && <div className="text-danger text-xs mt-1">{errors.agencyType}</div>}
                </div>
                {isOtherAgencyType && (
                  <div>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Other Type <span style={{color: 'var(--color-danger)'}}>*</span></label>
                    <input type="text" className="input-field" required placeholder="Specify other type" value={otherAgencyType} onChange={e => setOtherAgencyType(e.target.value)} />
                  {errors.otherAgencyType && <div className="text-danger text-xs mt-1">{errors.otherAgencyType}</div>}
                  </div>
                )}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Agency / Shop Name <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="text" className="input-field" required placeholder="e.g. Acme Printing Shop" value={shopName} onChange={e => setShopName(e.target.value)} />
                  {errors.shopName && <div className="text-danger text-xs mt-1">{errors.shopName}</div>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Phone Number <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <div style={{ position: 'relative' }}>
                    <span style={{ position: 'absolute', left: '1px', top: '1px', bottom: '1px', display: 'flex', alignItems: 'center', padding: '0 0.75rem', backgroundColor: '#f1f5f9', borderRight: '1px solid var(--color-border)', borderTopLeftRadius: 'calc(var(--border-radius-sm) - 1px)', borderBottomLeftRadius: 'calc(var(--border-radius-sm) - 1px)', color: 'var(--color-text-muted)', fontWeight: '600', fontSize: '0.9rem', pointerEvents: 'none' }}>+91</span>
                    <input type="tel" className="input-field" required placeholder="98765 43210" value={phone} maxLength="10" onChange={e => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))} style={{ width: '100%', paddingLeft: '3.5rem' }} />
                  </div>
                  {errors.phone && <div className="text-danger text-xs mt-1">{errors.phone}</div>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Email Address <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="email" className="input-field" required placeholder="email@example.com" value={email} onChange={e => setEmail(e.target.value)} />
                  {errors.email && <div className="text-danger text-xs mt-1">{errors.email}</div>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Address Line 1 <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="text" className="input-field" required placeholder="Street Address" value={address} onChange={e => setAddress(e.target.value)} />
                  {errors.address && <div className="text-danger text-xs mt-1">{errors.address}</div>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Address Line 2</label>
                  <input type="text" className="input-field" placeholder="Apt, Suite, etc." value={address2} onChange={e => setAddress2(e.target.value)} />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>City <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="text" className="input-field" required value={city} onChange={e => setCity(e.target.value)} />
                  {errors.city && <div className="text-danger text-xs mt-1">{errors.city}</div>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>State <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="text" className="input-field" required value={state} onChange={e => setState(e.target.value)} />
                  {errors.state && <div className="text-danger text-xs mt-1">{errors.state}</div>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Pincode <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="text" className="input-field" required value={pincode} onChange={e => setPincode(e.target.value)} />
                  {errors.pincode && <div className="text-danger text-xs mt-1">{errors.pincode}</div>}
                </div>
              </div>
            </div>

            {/* Section 2: Contact Details */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-6 border-b pb-3" style={{ borderColor: 'var(--color-border)' }}>
                <CheckCircle2 size={22} color="var(--color-primary)" />
                <h3 style={{ fontSize: '0.95rem', fontWeight: '700', color: 'var(--color-primary)', margin: 0 }}>Contact Details</h3>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Contact Person <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="text" className="input-field" required placeholder="Full Name" value={contactPerson} onChange={e => setContactPerson(e.target.value)} />
                  {errors.contactPerson && <div className="text-danger text-xs mt-1">{errors.contactPerson}</div>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Phone Number <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <div style={{ position: 'relative' }}>
                    <span style={{ position: 'absolute', left: '1px', top: '1px', bottom: '1px', display: 'flex', alignItems: 'center', padding: '0 0.75rem', backgroundColor: '#f1f5f9', borderRight: '1px solid var(--color-border)', borderTopLeftRadius: 'calc(var(--border-radius-sm) - 1px)', borderBottomLeftRadius: 'calc(var(--border-radius-sm) - 1px)', color: 'var(--color-text-muted)', fontWeight: '600', fontSize: '0.9rem', pointerEvents: 'none' }}>+91</span>
                    <input type="tel" className="input-field" required placeholder="98765 43210" value={contactPhone} maxLength="10" onChange={e => setContactPhone(e.target.value.replace(/\D/g, '').slice(0, 10))} style={{ width: '100%', paddingLeft: '3.5rem' }} />
                  </div>
                  {errors.contactPhone && <div className="text-danger text-xs mt-1">{errors.contactPhone}</div>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Email Address</label>
                  <input type="email" className="input-field" placeholder="email@example.com" value={contactEmail} onChange={e => setContactEmail(e.target.value)} />
                  {errors.contactEmail && <div className="text-danger text-xs mt-1">{errors.contactEmail}</div>}
                </div>
              </div>
            </div>

            {/* Section 3: Product Interest */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-6 border-b pb-3" style={{ borderColor: 'var(--color-border)' }}>
                <Tag size={22} color="var(--color-primary)" />
                <h3 style={{ fontSize: '0.95rem', fontWeight: '700', color: 'var(--color-primary)', margin: 0 }}>Product Interest</h3>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Interest Type <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <Dropdown
                    placeholder="Select Interest..."
                    value={interestedType}
                    onChange={handleInterestTypeChange}
                    options={[
                      { value: 'Interested in machine', label: 'Interested in machine' },
                      { value: 'In Future', label: 'In Future' },
                      { value: 'Not at all', label: 'Not at all' }
                    ]}
                  />
                  {errors.interestedType && <div className="text-danger text-xs mt-1">{errors.interestedType}</div>}
                </div>

                {(interestedType === 'Interested in machine' || interestedType === 'In Future') && (
                  <>
                    <div className="fade-in">
                      <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Machine Type <span style={{color: 'var(--color-danger)'}}>*</span></label>
                      <Dropdown
                        placeholder="Select Machine Type..."
                        value={machineType}
                        onChange={(val) => setMachineType(val)}
                        options={[
                          { value: 'rental', label: 'Rental Machine' },
                          { value: 'new', label: 'New Machine' }
                        ]}
                      />
                  {errors.machineType && <div className="text-danger text-xs mt-1">{errors.machineType}</div>}
                    </div>
                    <div className="fade-in">
                      <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Machine Brand <span style={{color: 'var(--color-danger)'}}>*</span></label>
                      <Dropdown
                        placeholder="Select Machine..."
                        value={machineBrand}
                        onChange={(val) => setMachineBrand(val)}
                        options={machines.map(m => ({ value: m.name, label: m.name }))}
                      />
                  {errors.machineBrand && <div className="text-danger text-xs mt-1">{errors.machineBrand}</div>}
                    </div>
                    <div className="fade-in">
                      <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Machine Model <span style={{color: 'var(--color-danger)'}}>*</span></label>
                      <input 
                        type="text" 
                        className="input-field"
                        value={machineModel}
                        onChange={(e) => setMachineModel(e.target.value)}
                        placeholder="e.g. IR 3225"
                        required
                      />
                  {errors.machineModel && <div className="text-danger text-xs mt-1">{errors.machineModel}</div>}
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Section 4: Tracking & Assignment */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-6 border-b pb-3" style={{ borderColor: 'var(--color-border)' }}>
                <CheckCircle2 size={22} color="var(--color-primary)" />
                <h3 style={{ fontSize: '0.95rem', fontWeight: '700', color: 'var(--color-primary)', margin: 0 }}>Tracking & Assignment</h3>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Initial Status <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <Dropdown
                    placeholder="Select Status..."
                    value={status}
                    onChange={(val) => setStatus(val)}
                    options={statuses.map(s => ({ value: s.name, label: s.name }))}
                  />
                  {errors.status && <div className="text-danger text-xs mt-1">{errors.status}</div>}
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Assign To Executive <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <Dropdown
                    placeholder="Select Executive..."
                    value={assignee || currentUser?.name || ''}
                    onChange={(val) => {
                      if (true || currentUser?.role === 'Admin') {
                        setAssignee(val);
                      }
                    }}
                    options={[
                      ...(currentUser?.name && !users.some(u => u.name === currentUser.name) ? [{ value: currentUser.name, label: `${currentUser.name} (You)` }] : []),
                      ...users.map(u => ({ value: u.name, label: `${u.name} (${u.role})` }))
                    ]}
                  />
                  {errors.assignee && <div className="text-danger text-xs mt-1">{errors.assignee}</div>}
                </div>
                
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Customer Type <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <Dropdown
                    placeholder="Select Customer Type..."
                    value={customerType}
                    onChange={(val) => setCustomerType(val)}
                    options={customerTypes.map(c => ({ value: c.name, label: c.name }))}
                  />
                  {errors.customerType && <div className="text-danger text-xs mt-1">{errors.customerType}</div>}
                </div>
                
                {status && (status.toLowerCase().includes('schedule') || status.toLowerCase().includes('follow')) && (
                  <div className="fade-in" style={{ gridColumn: 'span 3', backgroundColor: '#f0f9ff', padding: '1.5rem', borderRadius: '8px', border: '1px solid #bae6fd' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
                      <div>
                        <label className="text-sm font-semibold mb-2 block" style={{ color: '#0369a1' }}>Follow-up In (Days) <span style={{color: 'var(--color-danger)'}}>*</span></label>
                        <input 
                          type="number" 
                          className="input-field" 
                          placeholder="e.g. 10"
                          min="0"
                          value={followUpDays} 
                          onChange={(e) => handleFollowUpDaysChange(e.target.value)} 
                          required
                          style={{ backgroundColor: 'white' }}
                        />
                      </div>
                      <div>
                        <label className="text-sm font-semibold mb-2 block" style={{ color: '#0369a1' }}>Calculated Follow-up Date</label>
                        <div className="custom-datepicker-wrapper">
                          <DatePicker
                            selected={followUpDate ? new Date(followUpDate) : null}
                            onChange={(date) => handleFollowUpDateChange(date)}
                            className="input-field"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="DD/MM/YYYY"
                            minDate={new Date()}
                            style={{ backgroundColor: 'white' }}
                          />
                        </div>
                      </div>
                      <div>
                        <label className="text-sm font-semibold mb-2 block" style={{ color: '#0369a1' }}>Follow-up Time <span style={{color: 'var(--color-danger)'}}>*</span></label>
                        <div className="custom-datepicker-wrapper">
                          <DatePicker
                            selected={(() => {
                              if (!followUpTime) return null;
                              const d = new Date();
                              const [h, m] = followUpTime.split(':');
                              d.setHours(parseInt(h, 10), parseInt(m, 10), 0, 0);
                              return d;
                            })()}
                            onChange={(date) => {
                              if (date) {
                                const hours = String(date.getHours()).padStart(2, '0');
                                const mins = String(date.getMinutes()).padStart(2, '0');
                                setFollowUpTime(`${hours}:${mins}`);
                              } else {
                                setFollowUpTime('');
                              }
                            }}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="hh:mm aa"
                            className="input-field"
                            placeholderText="Select Time"
                            required
                            minTime={
                              followUpDate && new Date(followUpDate).setHours(0,0,0,0) === new Date().setHours(0,0,0,0)
                                ? new Date()
                                : new Date(new Date().setHours(0, 0, 0, 0))
                            }
                            maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            
            {/* Section 5: Visiting Card Images */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-6 border-b pb-3" style={{ borderColor: 'var(--color-border)' }}>
                <FileText size={22} color="var(--color-primary)" />
                <h3 style={{ fontSize: '0.95rem', fontWeight: '700', color: 'var(--color-primary)', margin: 0 }}>Visiting Card (Optional)</h3>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1.5rem' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Front Side Image</label>
                  <div style={{ border: '2px dashed var(--color-border)', borderRadius: '12px', padding: '1.5rem', textAlign: 'center', backgroundColor: frontCard ? 'var(--color-primary-light)' : '#f8fafc', position: 'relative', overflow: 'hidden', transition: 'all 0.2s', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <input type="file" accept="image/*" onChange={(e) => setFrontCard(e.target.files[0])} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer', zIndex: 10 }} />
                    {frontCard ? (
                      <img 
                        src={typeof frontCard === 'string' ? frontCard : URL.createObjectURL(frontCard)} 
                        alt="Front Card" 
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', zIndex: 1 }} 
                      />
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                        <UploadCloud size={24} color={'var(--color-text-muted)'} />
                        <span style={{ fontSize: '0.875rem', fontWeight: '500', color: 'var(--color-text-main)' }}>
                          Click to upload front side
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>Back Side Image</label>
                  <div style={{ border: '2px dashed var(--color-border)', borderRadius: '12px', padding: '1.5rem', textAlign: 'center', backgroundColor: backCard ? 'var(--color-primary-light)' : '#f8fafc', position: 'relative', overflow: 'hidden', transition: 'all 0.2s', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <input type="file" accept="image/*" onChange={(e) => setBackCard(e.target.files[0])} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer', zIndex: 10 }} />
                    {backCard ? (
                      <img 
                        src={typeof backCard === 'string' ? backCard : URL.createObjectURL(backCard)} 
                        alt="Back Card" 
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', zIndex: 1 }} 
                      />
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                        <UploadCloud size={24} color={'var(--color-text-muted)'} />
                        <span style={{ fontSize: '0.875rem', fontWeight: '500', color: 'var(--color-text-main)' }}>
                          Click to upload back side
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Section 6: Additional Notes */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-4">
                <FileText size={20} color="var(--color-text-muted)" />
                <h3 className="text-lg font-semibold">Additional Notes</h3>
              </div>
              <textarea className="input-field w-full" rows="3" placeholder="Add any initial conversation notes, special requirements, or follow-up instructions here..." value={notes} onChange={e => setNotes(e.target.value)}></textarea>
            </div>
          </fieldset>

          <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1.25rem' }}>
            <button type="button" onClick={onClose} className="btn" style={{ padding: '0.5rem 1.5rem', border: '1px solid var(--color-border)', borderRadius: '12px', background: 'white', cursor: 'pointer', fontWeight: '500' }}>Cancel</button>
            <button type="submit" disabled={isSubmitting} className="btn btn-primary" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1.5rem', border: 'none', borderRadius: '12px', background: 'var(--color-primary)', color: 'white', cursor: 'pointer', fontWeight: '500' }}>
              {isSubmitting && <Loader2 size={16} className="spinner-icon" />}
              {isSubmitting ? 'Saving...' : (initialData ? 'Save Changes' : 'Create Lead')}
            </button>
          </div>
        </form>
      </div>
      
      <style>{`
        .fade-in {
          animation: fadeIn 0.3s ease-in-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-5px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default AddLead;
